export default __webpack_public_path__ + "static/media/logo.fdcaa3d6.png";